/* eslint-disable no-unused-vars */
import { RECOMMENDATION_TYPES } from '@bingads-webui-campaign/recommendation-core';
import { reasonsMapping } from './dismiss-feedback-const';

export const OTHER_REASON = 'Other';
export const REASON_TABLE = {
  [RECOMMENDATION_TYPES.BUDGET_OPPORTUNITY]: [
    'BudgetNoBudget',
    'BudgetTooHigh',
    'BudgetCpcTooHigh',
    'BudgetDoLater',
    'BudgetOther',
  ],
  [RECOMMENDATION_TYPES.FIX_CONVERSION_GOAL_SETTINGS]: [
    'FixConvGoalFixItLater',
    'FixConvGoalCurrentSettingCorrect',
    'FixConvGoalNeedAssistanceToFix',
    'FixConvGoalAlreadyFixed',
    'FixConvGoalGoalNotUse',
    'FixConvGoalOther',
  ],
  [RECOMMENDATION_TYPES.CREATE_CONVERSION_GOAL]: [
    'CreateConvGoalCreateItLater',
    'CreateConvGoalNotInterested',
    'CreateConvGoalGoalTypeNotMatched',
    'CreateConvGoalAlreadyExist',
    'CreateConvGoalInappropriateSuggestion',
    'CreateConvGoalOther',
  ],
  budgetLandscape: [
    'NoBudget',
    'RecommendedBudgetHigh',
    'CPCHigh',
    OTHER_REASON,
  ],
  [RECOMMENDATION_TYPES.REPAIR_ADS]: [
    'RepairAdsAlreadyAddressed',
    'RepairAdsPendingEditorial',
    'RepairAdsDsaAsSearch',
    'RepairAdsIntentional',
    'RepairAdsAddressOutside',
    'RepairAdsOther',
  ],
  [RECOMMENDATION_TYPES.REPAIR_KEYWORD]: [
    'RepairKeywordsAlreadyAddressed',
    'RepairKeywordsPendingEditorial',
    'RepairKeywordsDsaAsSearch',
    'RepairKeywordsIntentional',
    'RepairKeywordsAddressOutside',
    'RepairKeywordsOther',
  ],
  [RECOMMENDATION_TYPES.FIX_AD_TEXT]: [
    'FixAdContWIP',
    'FixAdContWontFix',
    'FixAdContResolveOutsideAds',
    'FixAdContOther',
  ],
  [RECOMMENDATION_TYPES.FIX_AD_DESTINATION]: [
    'FixAdDestWIP',
    'FixAdDestWontFix',
    'FixAdDestResolveOutsideAds',
    'FixAdDestOther',
  ],
  [RECOMMENDATION_TYPES.SETUP_CONVERSION_TRACKING_OPPORTUNITY]: [
    'SetupConvDoItLater',
    'SetupConvNeedAssistance',
    'SetupConvWorking',
    'SetupConvCannotMakeChanges',
    'SetupConvUseOtherTool',
    'SetupConvNotRelevant',
    'SetupConvOther',
  ],
};

// don't have to know which opt those reasons belong to
export const PERCENT_INPUT_REASON_LIST = [
  'BudgetTooHigh',
  'RecommendedBudgetHigh',
];

export const NUMBER_INPUT_REASON_LIST = [
  'BudgetCpcTooHigh',
  'CPCHigh',
];

export const COMMENT_ONLY_REASON_LIST = [
  'FixConvGoalGoalNotUse',
];

export const COMMENT_WITH_URL_REASON_LIST = [
  'FixConvGoalNeedAssistanceToFix',
];

export const URL_FOR_COMMENT_WITH_URL_REASON_LIST = {
  [COMMENT_WITH_URL_REASON_LIST.FixConvGoalNeedAssistanceToFix]: 'http://go.microsoft.com/fwlink/?LinkId=258669',
};

export const RECOMMENDATION_TYPES_SUPPORT_NEW_DISMISS_FORM = {
  [RECOMMENDATION_TYPES.BUDGET_OPPORTUNITY]: true,
  [RECOMMENDATION_TYPES.FIX_CONVERSION_GOAL_SETTINGS]: true,
  [RECOMMENDATION_TYPES.CREATE_CONVERSION_GOAL]: true,
  budgetLandscape: true,
};

export const RECOMMENDATION_REASON_TO_COMMENT_TRANSLATOR = {
  BudgetTooHigh: 'Recommendation_Feedback_Reason_BudgetHigh_Comment',
  BudgetCpcTooHigh: 'Recommendation_Feedback_Reason_CPCHigh_Comment',
  RecommendedBudgetHigh: 'Recommendation_Feedback_Reason_BudgetHigh_Comment',
  CPCHigh: 'Recommendation_Feedback_Reason_CPCHigh_Comment',
  FixConvGoalNeedAssistanceToFix: 'Recommendation_Dismiss_Feedback_NeedAssistanceToFix_Comment',
  FixConvGoalGoalNotUse: 'Recommendation_Dismiss_Feedback_GoalNotUse_Comment',
};

export function isNewFeedbackOpportunity(RecommendationType) {
  return RecommendationType in REASON_TABLE;
}

